import './InputLabel.css';

import clsx from 'clsx';
import { ReactNode, useId } from 'react';
import { informationCircleOutline } from 'ionicons/icons';
import { IonIcon, IonLabel } from '@ionic/react';
import Tooltip from '../Tooltip/Tooltip';

interface InputLabelProps {
  children: ReactNode;
  className?: string;
  hint?: string;
}

const InputLabel = ({ children, className, hint }: InputLabelProps) => {
  const id = useId();

  return (
    <div className={clsx('input-label-container', className)}>
      <IonLabel className="input-label">{children}</IonLabel>
      {hint && (
        <>
          <IonIcon
            className={clsx('input-label-hint-icon', id)}
            icon={informationCircleOutline}
            data-pr-tooltip={hint}
            data-pr-position="top"
            data-pr-at="center top"
            data-pr-my="center bottom-5"
          />
          <Tooltip target={`.${id}`} className="input-label-tooltip" />
        </>
      )}
    </div>
  );
};

export default InputLabel;
